import React, { useState } from "react";
import { useFilter } from "../context/FilterProjectsContext";
import "../styles/projects.css";
const ProjectsSideBar = ({ onSelect }) => {
  const { selectedFilter, activeFolder, setSelectedFilter, setActiveFolder } =
    useFilter();
  const handleChange = (folderName) => {
    setActiveFolder(folderName);
    if (onSelect) {
      onSelect(folderName);
    }
    setSelectedFilter(folderName);
    // Scroll to top when project changes
    setTimeout(() => {
      const projectsPanel = document.querySelector(".projects-panel.panel");
      if (projectsPanel) {
        projectsPanel.scrollTo(0, 0);
      }
    }, 0);
  };

  return (
    <div className="projects-sidebar">
      <div className="folder-header">
        <div className="cell">
          {" "}
          <i className="fa-solid fa-sort-down"></i> mert-projects
        </div>
      </div>
      <div className="folders">
        <div className="folder active">
          <div
            className={`overview  ${
              activeFolder === "overview" ? "active" : ""
            }`}
            onClick={() => handleChange("overview")}
          >
            {" "}
            <i className="fa-solid fa-chevron-down "></i>{" "}
            <i className="fa-solid fa-folder main-folder"></i> projects
          </div>
          <br className="mobile-hide" />
          <div
            className={`subfile livemap  ${
              activeFolder === "livemap" ? "active" : ""
            }`}
            onClick={() => handleChange("livemap")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> liveMap
          </div>
          <div
            className={`subfile mertgpt  ${
              activeFolder === "mertgpt" ? "active" : ""
            }`}
            onClick={() => handleChange("mertgpt")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> arncAI
          </div>
          <div
            className={`subfile autoseo ${
              activeFolder === "autoseo" ? "active" : ""
            }`}
            onClick={() => handleChange("autoseo")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> autoSEO
          </div>
          <div
            className={`subfile mertcloud ${
              activeFolder === "mertcloud" ? "active" : ""
            }`}
            onClick={() => handleChange("mertcloud")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> mertCloud
          </div>

          <div
            className={`subfile kioskquiz ${
              activeFolder === "kioskquiz" ? "active" : ""
            }`}
            onClick={() => handleChange("kioskquiz")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> kioskQuiz
          </div>

          {/* <div
            className={`subfile talksai ${
              activeFolder === "talksai" ? "active" : ""
            }`}
            onClick={() => handleChange("talksai")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> talksAI
          </div> */}
          <div
            className={`subfile pixelpals ${
              activeFolder === "pixelpals" ? "active" : ""
            }`}
            onClick={() => handleChange("pixelpals")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> pixelPals
          </div>
          {/* <div
            className={`subfile eventinv ${
              activeFolder === "eventinv" ? "active" : ""
            }`}
            onClick={() => handleChange("eventinv")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> eventInv
          </div> */}
          {/* <div
            className={`subfile mertshop ${
              activeFolder === "mertshop" ? "active" : ""
            }`}
            onClick={() => handleChange("mertshop")}
          >
            {" "}
            <i className="fa-solid fa-chevron-right"></i>{" "}
            <i className="fa-solid fa-folder"></i> mertShop
          </div> */}
        </div>
      </div>

      <div className="cell border-top contact-box">
        {" "}
        <i className="fa-solid fa-sort-down"></i> contact
      </div>

      <div className="folders contact-folders">
        <div className="folder link-folder">
          <i className="fa-solid fa-phone"></i>{" "}
          <a className="folder-link" href="tel:0031616150171">
            +31 616 15 01 71
          </a>
        </div>
        <div className="folder link-folder">
          <i className="fa-solid fa-envelope"></i>{" "}
          <a className="folder-link" href="mailto:mertarinci96@gmail.com">
            emailMe.js
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectsSideBar;
